// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  // Travel package
  getTravelPackageRequest: ['data'],
  getTravelPackageSuccess: ['data'],
  getTravelPackageFailure: ['err'],

  postTravelPackageRequest: ['data'],
  postTravelPackageSuccess: ['data'],
  postTravelPackageFailure: ['err'],

  putTravelPackageRequest: ['data'],
  putTravelPackageSuccess: ['data'],
  putTravelPackageFailure: ['err'],

  deleteTravelPackageRequest: ['data'],
  deleteTravelPackageSuccess: ['data'],
  deleteTravelPackageFailure: ['err'],

  viewTravelPackageRequest: ['data'],
  viewTravelPackageSuccess: ['data'],
  viewTravelPackageFailure: ['err'],

  postTravelPackagePriceRequest: ['data'],
  postTravelPackagePriceSuccess: ['data'],
  postTravelPackagePriceFailure: ['err'],

  putTravelPackagePriceRequest: ['data'],
  putTravelPackagePriceSuccess: ['data'],
  putTravelPackagePriceFailure: ['err'],

  switchTravelPackagePriceRequest: ['data'],
  switchTravelPackagePriceSuccess: ['data'],
  switchTravelPackagePriceFailure: ['err'],

  getTicketPackageRequest: ['data'],
  getTicketPackageSuccess: ['data'],
  getTicketPackageFailure: ['err'],

  postTicketPackageRequest: ['data'],
  postTicketPackageSuccess: ['data'],
  postTicketPackageFailure: ['err'],

  putTicketPackageRequest: ['data'],
  putTicketPackageSuccess: ['data'],
  putTicketPackageFailure: ['err'],

  deleteTicketPackageRequest: ['data'],
  deleteTicketPackageSuccess: ['data'],
  deleteTicketPackageFailure: ['err']
})

export const InsuranceTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  data_view: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) => state.merge({ fetching: true, err: null, success: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
    // success: null
  })

export const successView = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data_view: data,
    err: null
    // success: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const failureView = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err, data_view: {} })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null, err: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_TRAVEL_PACKAGE_SUCCESS]: success,
  [Types.GET_TRAVEL_PACKAGE_REQUEST]: request,
  [Types.GET_TRAVEL_PACKAGE_FAILURE]: failure,

  [Types.POST_TRAVEL_PACKAGE_SUCCESS]: success,
  [Types.POST_TRAVEL_PACKAGE_REQUEST]: request,
  [Types.POST_TRAVEL_PACKAGE_FAILURE]: failure,

  [Types.PUT_TRAVEL_PACKAGE_SUCCESS]: manipulateSuccess,
  [Types.PUT_TRAVEL_PACKAGE_REQUEST]: manipulateRequest,
  [Types.PUT_TRAVEL_PACKAGE_FAILURE]: manipulateFailure,

  [Types.DELETE_TRAVEL_PACKAGE_SUCCESS]: manipulateSuccess,
  [Types.DELETE_TRAVEL_PACKAGE_REQUEST]: manipulateRequest,
  [Types.DELETE_TRAVEL_PACKAGE_FAILURE]: manipulateFailure,

  [Types.VIEW_TRAVEL_PACKAGE_SUCCESS]: successView,
  [Types.VIEW_TRAVEL_PACKAGE_REQUEST]: request,
  [Types.VIEW_TRAVEL_PACKAGE_FAILURE]: failureView,

  [Types.POST_TRAVEL_PACKAGE_PRICE_SUCCESS]: manipulateSuccess,
  [Types.POST_TRAVEL_PACKAGE_PRICE_REQUEST]: manipulateRequest,
  [Types.POST_TRAVEL_PACKAGE_PRICE_FAILURE]: manipulateFailure,

  [Types.PUT_TRAVEL_PACKAGE_PRICE_SUCCESS]: manipulateSuccess,
  [Types.PUT_TRAVEL_PACKAGE_PRICE_REQUEST]: manipulateRequest,
  [Types.PUT_TRAVEL_PACKAGE_PRICE_FAILURE]: manipulateFailure,

  [Types.SWITCH_TRAVEL_PACKAGE_PRICE_SUCCESS]: manipulateSuccess,
  [Types.SWITCH_TRAVEL_PACKAGE_PRICE_REQUEST]: manipulateRequest,
  [Types.SWITCH_TRAVEL_PACKAGE_PRICE_FAILURE]: manipulateFailure,

  [Types.GET_TICKET_PACKAGE_SUCCESS]: success,
  [Types.GET_TICKET_PACKAGE_REQUEST]: request,
  [Types.GET_TICKET_PACKAGE_FAILURE]: failure,

  [Types.POST_TICKET_PACKAGE_SUCCESS]: success,
  [Types.POST_TICKET_PACKAGE_REQUEST]: request,
  [Types.POST_TICKET_PACKAGE_FAILURE]: failure,

  [Types.PUT_TICKET_PACKAGE_SUCCESS]: manipulateSuccess,
  [Types.PUT_TICKET_PACKAGE_REQUEST]: manipulateRequest,
  [Types.PUT_TICKET_PACKAGE_FAILURE]: manipulateFailure,

  [Types.DELETE_TICKET_PACKAGE_SUCCESS]: manipulateSuccess,
  [Types.DELETE_TICKET_PACKAGE_REQUEST]: manipulateRequest,
  [Types.DELETE_TICKET_PACKAGE_FAILURE]: manipulateFailure
})



// WEBPACK FOOTER //
// ./src/Redux/InsuranceRedux.js